import { render, staticRenderFns } from "./received-items.vue?vue&type=template&id=9dda4e28&"
import script from "./received-items.vue?vue&type=script&lang=js&"
export * from "./received-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports